export enum CmsProductGeographicalZoneEnum {
  national = "national",
  regional = "regional",
  local = "local",
}
